import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { PatientCurrentVisitFragmentDoc } from '../../__generated__/details-graphql.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PatientCentreOnlineOnlyFieldsQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type PatientCentreOnlineOnlyFieldsQuery = { readonly __typename?: 'Query', readonly patientByCardId?: { readonly __typename?: 'PatientByCardIdResult', readonly passportId?: string | null, readonly patient: { readonly __typename?: 'Patient', readonly uuid: string, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly paymentUpToDate?: boolean | null, readonly expiryDate?: string | null, readonly insuranceDetails?: unknown | null, readonly visitValidation?: { readonly __typename?: 'PatientInsuranceVisitValidation', readonly expiryStrategy?: string | null } | null, readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } | null, readonly currentVisit?: { readonly __typename?: 'Visit', readonly _id: string, readonly expiryStrategy?: Types.VisitExpiryStrategy | null, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null } | null, readonly insuranceList?: ReadonlyArray<{ readonly __typename?: 'InsuranceListItem', readonly isValidForVisit?: boolean | null, readonly visitInsuranceDetails?: unknown | null, readonly insurance: { readonly __typename?: 'VisitInsurance', readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly insuranceType?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } } | null> | null } | null, readonly registrationPayment: { readonly __typename?: 'RegistrationPaymentOverview', readonly status: Types.PaymentStatus }, readonly card?: { readonly __typename?: 'PatientCard', readonly id?: string | null } | null } } | null };


export const PatientCentreOnlineOnlyFieldsDocument = gql`
    query PatientCentreOnlineOnlyFields($id: String!) {
  patientByCardId(uuid: $id) {
    patient {
      uuid
      insurance {
        insuranceType
        insuranceNumber
        paymentUpToDate
        expiryDate
        visitValidation {
          expiryStrategy
        }
        insuranceProvider {
          name
          visitValidation {
            expiryStrategy
          }
        }
        insuranceDetails
      }
      currentVisit {
        ...PatientCurrentVisit
      }
      registrationPayment {
        status
      }
      card {
        id
      }
    }
    passportId
  }
}
    ${PatientCurrentVisitFragmentDoc}`;

/**
 * __usePatientCentreOnlineOnlyFieldsQuery__
 *
 * To run a query within a React component, call `usePatientCentreOnlineOnlyFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientCentreOnlineOnlyFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientCentreOnlineOnlyFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePatientCentreOnlineOnlyFieldsQuery(baseOptions: Apollo.QueryHookOptions<PatientCentreOnlineOnlyFieldsQuery, PatientCentreOnlineOnlyFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientCentreOnlineOnlyFieldsQuery, PatientCentreOnlineOnlyFieldsQueryVariables>(PatientCentreOnlineOnlyFieldsDocument, options);
      }
export function usePatientCentreOnlineOnlyFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientCentreOnlineOnlyFieldsQuery, PatientCentreOnlineOnlyFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientCentreOnlineOnlyFieldsQuery, PatientCentreOnlineOnlyFieldsQueryVariables>(PatientCentreOnlineOnlyFieldsDocument, options);
        }
export type PatientCentreOnlineOnlyFieldsQueryHookResult = ReturnType<typeof usePatientCentreOnlineOnlyFieldsQuery>;
export type PatientCentreOnlineOnlyFieldsLazyQueryHookResult = ReturnType<typeof usePatientCentreOnlineOnlyFieldsLazyQuery>;
export type PatientCentreOnlineOnlyFieldsQueryResult = Apollo.QueryResult<PatientCentreOnlineOnlyFieldsQuery, PatientCentreOnlineOnlyFieldsQueryVariables>;